import { MerchantPublicConfigurationModel } from '@merchant-clients/configuration';

import { KeyValueStore } from '@frontend/utils';

interface MerchantPublicConfigurationCacheModel
  extends MerchantPublicConfigurationModel {
  appVersionHash: string | undefined;
}

export const merchantPublicConfigurationCache = {
  async get(): Promise<MerchantPublicConfigurationCacheModel | undefined> {
    const cached = await KeyValueStore.get('merchant-public-configuration');

    if (!cached) {
      return undefined;
    }

    return JSON.parse(cached);
  },

  async set(
    configuration: MerchantPublicConfigurationCacheModel,
  ): Promise<void> {
    await KeyValueStore.set(
      'merchant-public-configuration',
      JSON.stringify(configuration),
    );
  },
};
